import SortIcons from "./SortIcons";

/**
 * Sortable table column header button with sort-direction icons.
 *
 * @param {object} props
 * @param {string} props.label - Column label text.
 * @param {string} props.field - Sort field identifier.
 * @param {string | null} props.sortedField - Active sort field, or null.
 * @param {boolean} props.isSortDescending - Whether sort is descending.
 * @param {(field: string) => void} props.onSort - Emits a sort request for a field.
 * @param {string} [props.className] - Class for the sort button.
 * @returns {import('react').JSX.Element}
 */
const SortableHeader = ({
    label,
    field,
    sortedField,
    isSortDescending,
    onSort,
    className,
}) => (
    <button
        type="button"
        className={className}
        onClick={() => onSort(field)}
    >
        {label}
        <SortIcons
            field={field}
            sortedField={sortedField}
            isSortDescending={isSortDescending}
        />
    </button>
);

export default SortableHeader;
